import React, { useRef, useState } from "react";
import TextComponent from "../textComponent/TextComponent";
import styles from "./TopTabComponent.module.css";

const TopTabComponent = (props) => {
  return (
    <div className={`${styles.TopTabListContainer} ${props?.TopTabListContainerStyle}`}>
      <div className={`${styles.TopTabList} ${props?.TopTabListStyle}`}>
        {props?.options?.map((tab) => {
          return (
            <div
              key={tab.id}
              onClick={() => props?.setFocused(tab)}
              className={`${styles.tab} ${props?.TabStyle}  ${props?.focused?.name == tab.name
                  ? `${styles.active} ${props?.ActiveTabStyle}`
                  : ""
                }`}
              style={{ borderRadius: tab?.Icon ? "32px" : "32px" }}
            >
              {tab?.Icon ? (
                <div className={styles.IconOuterDiv}>
                  <div
                    className={styles.IconInnerDiv}
                    style={{
                      backgroundColor:
                        props?.focused?.name == tab.name
                          ? "var(--primary-color)"
                          : "var(--white-color)",
                    }}
                  >
                    {" "}
                    {tab?.Icon}
                  </div>
                </div>
              ) : null}

              <TextComponent
                text={tab.name}
                fontSize={"var(--mobile-subheading)"}
                className={`${styles.tabText} ${props?.TabLabelStyle}  ${props?.focused?.name == tab.name
                    ? `${styles.active} ${props?.ActiveTabStyle}`
                    : ""
                  }`}
                // className={props?.TabLabelStyle}
                padding={props?.TabLabelpadding ? props?.TabLabelpadding : "0px"}
                color={props?.TabLabelColor}
              />

              {tab?.CloseIcon ? <div>{tab?.CloseIcon}</div> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopTabComponent;
